import {
  freshBooking,
  fetchEventDetails
} from '../../functions/calendar/calendarUtils.js'

export const CalMonthView = {
  flow: 'y',
  flex: '1',
  overflow: 'hidden',
  userSelect: 'none',
  display: (el, s) => (s.root.viewMode === 'month' ? 'flex' : 'none'),

  DayHeaders: {
    display: 'grid',
    gridTemplateColumns: 'repeat(7, 1fr)',
    borderBottomWidth: '1px',
    borderBottomColor: 'line',
    borderBottomStyle: 'solid',

    childExtends: 'CalMonthDayHeader',
    childrenAs: 'state',
    children: (el) => el.call('getDayNames').map((d) => ({ label: d }))
  },

  Grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(7, 1fr)',
    gridTemplateRows: 'repeat(6, 1fr)',
    flex: '1',
    overflow: 'hidden',

    childExtends: 'CalMonthDayCell',
    childrenAs: 'state',
    children: (el, s) => {
      const root = s.root
      return el.call('getMonthDays', root.currentYear, root.currentMonth)
    }
  }
}

export const CalMonthDayHeader = {
  tag: 'span',
  padding: 'Z1 A',
  fontSize: 'Y2',
  fontWeight: '500',
  color: 'caption',
  align: 'center left',
  text: (el, s) => s.label || ''
}

export const CalMonthDayCell = {
  flow: 'y',
  borderRightWidth: '1px',
  borderRightColor: 'line',
  borderRightStyle: 'solid',
  borderBottomWidth: '1px',
  borderBottomColor: 'line',
  borderBottomStyle: 'solid',
  padding: 'Z',
  overflow: 'hidden',
  cursor: 'pointer',
  minHeight: '0',
  background: (el, s) => {
    if (!s.isOtherMonth && el.call('isToday', s.year, s.month, s.day))
      return 'selectedDay'
    return 'transparent'
  },
  ':hover': { background: 'overlay' },
  onClick: (e, el, s) => {
    const root = el.state.root
    root.update({
      currentDay: s.day,
      currentMonth: s.month,
      currentYear: s.year,
      showNewBooking: true,
      newBooking: freshBooking({
        date: el.call('formatDate', s.year, s.month, s.day)
      })
    })
  },

  DayNum: {
    tag: 'span',
    width: 'B',
    height: 'B',
    round: '50%',
    align: 'center center',
    fontSize: 'Z2',
    fontWeight: (el, s) =>
      el.call('isToday', s.year, s.month, s.day) ? '700' : '400',
    background: (el, s) =>
      el.call('isToday', s.year, s.month, s.day) ? 'blue' : 'transparent',
    color: (el, s) => {
      if (s.isOtherMonth) return 'caption'
      if (el.call('isToday', s.year, s.month, s.day)) return 'white'
      return 'title'
    },
    opacity: (el, s) => (s.isOtherMonth ? '.35' : '1'),
    text: (el, s) => String(s.day),
    marginBottom: 'Y2'
  },

  Events: {
    flow: 'y',
    gap: 'Y2',
    overflow: 'hidden',
    flex: '1',

    childExtends: 'CalEventChip',
    childrenAs: 'state',
    children: (el, s) => {
      const root = el.state.root
      return el
        .call('getEventsForDay', root.events, s.year, s.month, s.day)
        .filter(
          (ev) => !ev.type || ev.type === 'meeting' || ev.type === 'general'
        )
        .slice(0, 3)
    }
  }
}

export const CalEventChip = {
  tag: 'button',
  flow: 'x',
  align: 'center left',
  padding: 'Y2 Z',
  round: 'Y',
  border: 'none',
  cursor: 'pointer',
  fontSize: 'Y2',
  fontWeight: '500',
  overflow: 'hidden',
  width: '100%',
  color: 'white',
  background: (el, s) => (s.type === 'general' ? 'blue' : 'green'),
  ':hover': { opacity: '.85' },
  onClick: (e, el, s) => {
    e.stopPropagation()
    const root = el.state.root
    root.update({ selectedEvent: s, showEventDetail: true })
    if (s.invitees === undefined || s.description === undefined)
      fetchEventDetails(s.id, root)
  },

  Time: {
    tag: 'span',
    text: (el, s) => s.startTime || '',
    opacity: '.8',
    marginRight: 'Y2',
    whiteSpace: 'nowrap'
  },
  Title: {
    tag: 'span',
    text: (el, s) => s.title || '',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }
}
